import React from 'react'
import { Dialog } from '@headlessui/react'
import { useTranslation } from 'react-i18next'

interface ConfirmPaymentModalProps {
  isOpen: boolean
  isRTL?: boolean
  isLoading?: boolean
  onClose: () => void
  onConfirm: () => void
}

const ConfirmPaymentModal: React.FC<ConfirmPaymentModalProps> = ({
  isOpen,
  isRTL = true,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation()

  const handleBackdrop = () => {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <Dialog open={isOpen} onClose={handleBackdrop} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          className={`w-full max-w-[400px] bg-white rounded-2xl overflow-hidden shadow-2xl ${isRTL ? 'text-right' : 'text-left'
            }`}
        >
          <div className="p-6 flex flex-col gap-4">
            <Dialog.Title className="text-lg font-bold text-black font-['IBM Plex Sans Arabic']">
              {t('orders.confirm_payment_popup_title', {
                defaultValue: 'Confirm Payment',
              })}
            </Dialog.Title>

            <p className="text-base font-normal text-black font-['IBM Plex Sans Arabic']">
              {t('orders.confirm_payment_popup_message', {
                defaultValue: 'Are you sure you want to confirm this payment?',
              })}
            </p>

            <div className="flex flex-col gap-3 mt-2">
              <button
                onClick={onConfirm}
                disabled={isLoading}
                className="w-full h-12 px-6 rounded-xl bg-flutter-button text-white font-medium font-['IBM Plex Sans Arabic'] transition-all active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading
                  ? t('orders.confirming_payment', { defaultValue: 'Confirming...' })
                  : t('orders.confirm_payment_popup_confirm', {
                    defaultValue: 'Yes, confirm payment',
                  })}
              </button>

              <button
                onClick={onClose}
                disabled={isLoading}
                className="w-full h-12 px-6 rounded-xl bg-white border border-gray-300 text-black font-medium font-['IBM Plex Sans Arabic'] hover:bg-gray-50 transition-all active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t('orders.confirm_payment_popup_cancel', {
                  defaultValue: t('common.cancel'),
                })}
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default ConfirmPaymentModal




